<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qRaaN/tc-custom/9781524856694.jpg?1729379544123" alt="This image is the cover for the book to drink coffee with a ghost"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">to drink coffee with a ghost
      </h1>
      <p class="bookDescription body article font2">
        <p>From the bestselling &amp; award-winning poetess, amanda lovelace, comes the finale of her illustrated duology, "things that h(a)unt." In the first installment, <i>to make monsters out of girls, </i> lovelace explored the memory of being in a toxic romantic relationship. In <i>to drink coffee with a ghost,</i> lovelace unravels the memory of the complicated relationship she had with her now-deceased mother.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda Lovelace
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21a67fc2